export const iterateEnum = <T extends object>(
    enumObj: T,
    callback: (value: T[keyof T]) => void,
) => {
    for (const key in enumObj)
        if (typeof enumObj[key] === "string") callback(enumObj[key]);
};

// for enums
export const mappingEnum = <T extends object>(enumObj: T) =>
    Object.entries(enumObj).flatMap(([key, value]) => ({
        key: key,
        value: value,
    }));
